import { SESSION_TIME_OUT } from '@/common/constants/ConstCode';
import routerInstance from '@/router/index';
import { useAccountStore } from '@/store/modules/account';
import { computed } from 'vue';
import { toastAlert } from '@/common/utils/module/ToastSupport';

/**
 * 토큰 체크
 */
const tokenCheck = (to, from, next) => {
  const accountStore = useAccountStore();
  if (!accountStore.accessToken && to.path !== '/' && to.path !== '/login') return false;
  else return true;
};

/**
 * 토큰 만료 시간 체크
 */
const sessionInvalidateCheck = (to, from, next) => {
  const accountStore = useAccountStore();

  const start = accountStore.sessionTime;
  const now = new Date().getTime();
  if (to.path === '/' || to.path === '/login') return true;
  if (!start) return false;
  if ((to.path !== '/' || to.path !== '/login') && start < now) {
    toastAlert('로그인 세션이 만료되었습니다.', 'error');
    return false;
  } else return true;
};

const notRegisteredRoutePath = (to, from, next) => pathsCheck(to.path);

const paths = computed(() => {
  return routerInstance
    .getRoutes()
    .map((e) => e.path)
    .map((e) => e.replaceAll(/(:\w+)/gi, `.*`))
    .map((e) => `^${e}$`);
});

const pathsCheck = (path) => {
  return paths.value.map((e) => new RegExp(e, 'gi')).filter((e) => e.test(path)).length > 0;
};

export { tokenCheck, sessionInvalidateCheck, notRegisteredRoutePath };
